export default __webpack_public_path__ + "static/quartuccia-logo-eec69802c73f6c23150360a645e7e261.png";